import { useEffect, useState, type RefObject } from "react";

// The full nav collapses to the floating pill only once the in-flow nav row
// itself leaves the viewport — a scroll-distance constant misfires on pages
// like home, where the nav floats over the hero.
export function useNavCollapse(
  navRef: RefObject<HTMLElement | null>,
  onBeforeChange?: (willCollapse: boolean) => void,
): boolean {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    const nav = navRef.current;
    if (!nav) {
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (entry === undefined) {
          return;
        }
        const willCollapse = !entry.isIntersecting;
        onBeforeChange?.(willCollapse);
        setCollapsed(willCollapse);
      },
      { threshold: 0 },
    );
    observer.observe(nav);
    return () => observer.disconnect();
  }, [navRef, onBeforeChange]);

  return collapsed;
}
